import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
    Container,
    Row,
    Col,
    Table,
    InputGroup,
    Form,
    Button,
    Card,
    Modal,
    Spinner,
} from "react-bootstrap";
import WebService from "../../Services/WebService";
import { useTranslation } from "react-i18next";
import Pagination from "../../components/Pagination/Pagination";
import Loader from "../../components/Loader/Loader";
import { IoCloseCircleOutline } from "react-icons/io5";
import NoDataFound from "../../assets/images/empty_item.svg";
import { GoSearch } from "react-icons/go";
import deleteIcon from "../../assets/images/delete.svg";
import { toast } from "react-toastify";
import { FaWallet } from "react-icons/fa";
import {
    FileEarmarkArrowDown,
    FileEarmarkArrowUp,
} from "react-bootstrap-icons";
import { AiOutlineEye } from "react-icons/ai";
import { useSelector } from "react-redux";
const UserSubscription = () => {

    const location = useLocation();
    const [loader, setLoader] = useState(false);
    const [list, setList] = useState<any[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const initialPage = location.state?.page || 1;
    const [page, setPage] = useState(initialPage);
    const [keyword, setKeyword] = useState("");
    const { t } = useTranslation();
    const [isSearchActive, setIsSearchActive] = useState(false);
    const [modalDeleteShow, setDeleteModalShow] = React.useState(false);
    const [deleteId, setDeleteId] = useState("");
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [currentColum, setcurrentColum] = useState("created_at");
    const [currentSort, setcurrentSort] = useState("DESC");
    const [type, setType] = useState("");
    const menuList = useSelector((state: any) => state.profile.menus);
    const subscriptionAccess = menuList.find(
        (menu: any) => menu.name === "User Subscription"
    )?.access;

    useEffect(() => {
        if (initialPage) {
            setPage(initialPage);
        }
    }, []);

    useEffect(() => {
        getSubscriptionsList(page, keyword);
    }, [page, currentColum, currentSort, isSearchActive, keyword]);

    const Search = (value: any) => {
        setPage(1);
        setIsSearchActive(true);
        getSubscriptionsList(1, value);
    }

    const getSubscriptionsList = (
        page: number,
        keyword?: string,
    ) => {
        setLoader(true);
        const offset = page - 1;
        const body = {
            offset: offset.toString(),
            keyword: keyword || "",
            sort_by: currentColum || "",
            sort_order: currentSort || "",
            type: type || "",
        };
        const queryParam = new URLSearchParams(body);
        WebService.getAPI({
            action: `get-subscription-list?` + queryParam,
            body: null,
            isShowError: true,
        })
            .then((res: any) => {
                setList(res.list);
                setTotalCount(res.count);
                setLoader(false);
            })
            .catch((error) => {
                setLoader(false);
            });
    };
    const handleCancelSubscription = (id: string) => {
        setDeleteId(id);
        setDeleteModalShow(true);
    };
    const handleConfirmCancel = () => {
        WebService.addLoader('cancel-subscription');
        WebService.postAPI({
            action: `cancel-subscription/${deleteId}`,
            body: null,
            isShowError: true,
        }).then((res: any) => {
            WebService.removeLoader('cancel-subscription');
            setDeleteLoader(false);
            setDeleteModalShow(false);
            toast.success(t("Subscription cancelled successfully"));
            getSubscriptionsList(page, keyword);
        }).catch((error) => {
            WebService.removeLoader('cancel-subscription');
            setDeleteLoader(false);
        });
    };
    return (
        <Container>
            <Row className="mb-3">
                <Col>
                    <h4 className="mb-4 text-primary">
                        User Subscription
                    </h4>
                </Col>
            </Row>
            <Card className="card-style mb-3">
                {subscriptionAccess && subscriptionAccess.can_read === "1" ? (
                    <>
                        <Card.Body>
                            <Row>
                                <Col md={3}>
                                    <InputGroup className="mb-3">
                                        <InputGroup.Text id="basic-addon1">
                                            <GoSearch />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder="Search"
                                            value={keyword}
                                            onChange={(e) => {
                                                setKeyword(e.target.value);
                                                Search(e.target.value);
                                            }}
                                            onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) => { }}
                                        />
                                    </InputGroup>
                                </Col>
                            </Row>
                            {!loader ? (
                                <div className="border-radius table-responsive">
                                    {list.length > 0 ? (
                                        <Table responsive="sm">
                                            <thead>
                                                <tr>
                                                    <th
                                                        className="cursor-pointer"
                                                    >
                                                        {t("Customer Name")}
                                                    </th>
                                                    <th
                                                        className="cursor-pointer"
                                                    >
                                                        {t("Mobile Number")}
                                                    </th>
                                                    <th
                                                        className="cursor-pointer"
                                                    >
                                                        {t("Item Name")}

                                                    </th>
                                                    <th
                                                        className="cursor-pointer"
                                                    >
                                                        {t("Quantity")}
                                                    </th>
                                                    <th
                                                        className="cursor-pointer"
                                                    >
                                                        {t("Start Date")}
                                                    </th>
                                                    <th
                                                        className="cursor-pointer"
                                                    >
                                                        {t("Slot Time")}
                                                    </th>
                                                    <th
                                                        className="cursor-pointer"
                                                    >
                                                        {t("Subscription Type")}
                                                    </th>
                                                    <th
                                                        className="cursor-pointer"
                                                    >
                                                        {t("Status")}
                                                    </th>
                                                    <th
                                                        className="cursor-pointer"
                                                    >
                                                        {t("Action")}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list.map((adminUserObj: any) => (
                                                    <tr key={adminUserObj.id}>
                                                        <td>{adminUserObj.user.first_name} {adminUserObj?.user.last_name}</td>
                                                        <td>
                                                            {adminUserObj?.user.mobile_number}
                                                        </td>
                                                        <td>{adminUserObj?.product_variant?.name}</td>
                                                        <td>{adminUserObj?.quantity}</td>
                                                        <td>{adminUserObj?.start_date}</td>
                                                        <td>
                                                            {adminUserObj?.slot_time}
                                                        </td>
                                                        <td>
                                                            {adminUserObj?.subscription_type}
                                                        </td>
                                                        <td>
                                                            {adminUserObj?.status}
                                                        </td>
                                                        <td>
                                                            {adminUserObj.status == 'ACTIVE' &&
                                                                <Button onClick={() => handleCancelSubscription(adminUserObj.id)}>Cancel</Button>
                                                            }
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    ) : (
                                        <div className="table-wrap position-relative text-center">
                                            <div className="no-data-flound">
                                                <div className="text-center">
                                                    <img
                                                        src={NoDataFound}
                                                        width={110}
                                                        className="mb-3"
                                                        alt="No Data"
                                                    />
                                                    <h3 className="text-secondary font-12">
                                                        {t("No Record Found")}
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {list.length > 0 && (
                                        <Pagination
                                            pagination={10}
                                            totalItems={totalCount}
                                            changePage={(page: number) => setPage(page)}
                                            changeCurrentPage={page}
                                        />
                                    )}
                                </div>
                            ) : (
                                <Loader show={loader} />
                            )}
                        </Card.Body>
                    </>
                ) : (
                    <>
                        {" "}
                        <div className="table-wrap position-relative text-center">
                            <div className="no-data-flound">
                                <div className="text-center">
                                    <img
                                        src={NoDataFound}
                                        width={110}
                                        alt=""
                                        className="mb-3"
                                    />
                                    <h3 className="text-secondary font-12">
                                        Sorry, You don't have access
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </Card>
            <Modal
                show={modalDeleteShow}
                onHide={() => setDeleteModalShow(false)}
                centered
                className="custom-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t("Confirm Cancellation")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t("Are you sure you want to cancel this subscription?")}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setDeleteModalShow(false)}>
                        {t("Close")}
                    </Button>
                    <Button variant="danger" id="cancel-subscription" onClick={handleConfirmCancel}>
                        {t("Confirm")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container >
    );
};

export default UserSubscription;
